


















import { Component, Prop, Vue } from 'vue-property-decorator'
import EquipProductCategory from '../../../modules/class/EquipProductCategory'
import EquipCard from '@/components/Card/EquipCard.vue'

@Component({
  components: {
    EquipCard
  }
})
export default class MypageEquipTopList extends Vue {
  // ------------------------------------------------------------------------------------------------
  // data
  @Prop({ required: true })
  readonly equipProductCategoryList!: EquipProductCategory[]
}
